import { ref, watchEffect } from "vue";

import type { WorkspaceDto } from "@/dto";
import { useApi } from "./api";

export function useWorkspaceFetcher(workspacePublicId: string) {
  const api = useApi();

  const workspace = ref<WorkspaceDto | null>(null);

  watchEffect(async () => {
    workspace.value = await api.fetchWorkspaceByPublicId(workspacePublicId);
  });

  return workspace;
}
